export const SPEC_RENDER_IDS = {
  DEDUCTIBLE: 'deductible'
};
